<div class="app" dir="ltr" [ngClass]="{'live-scenario': inLiveScenario}">
  <div kendoDialogContainer></div>
  <div class="app-body">
    <app-sidebar></app-sidebar>
    <main class="main">
      <div id="main" class="container-fluid">
        <div class="sidebar-content-container">
          <div class="sidebar-content">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </main>
  </div>
</div>
<app-default-version></app-default-version>